<template>
  <v-container fluid fill-height align-stretch>
    <v-row>
      <v-col cols="12" md="4">
        <v-container fluid>
          <v-row>
            <v-col cols="12">
              <v-tabs centered grow>
                <v-tab> Select </v-tab>
                <v-tab> Upload </v-tab>
                <v-tab-item>
                  <v-container>
                    <v-row>
                      <v-col cols="11">
                        <v-select
                          v-model="query_datasets"
                          :items="dataset_list"
                          :menu-props="{ top: true, offsetY: true }"
                          solo
                          multiple
                          chips
                          hint="Draw samples from the selected datasets"
                          persistent-hint
                        ></v-select>
                      </v-col>
                      <v-spacer></v-spacer>
                      <v-col cols="1" class="d-flex justify-center">
                        <v-btn
                          icon
                          large
                          color="primary"
                          @click="fetchSamples(true)"
                        >
                          <v-icon>mdi-cached</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row v-if="show_query_gallery" class="mt-0 pt-0">
                      <v-col cols="12" class="pt-0">
                        <ModelGallery
                          :addrPrefix="data_address"
                          :modelList="query_samples"
                          :nRow="query_n_row"
                          :nCol="query_n_col"
                          @select-it="select_query_sample(arguments)"
                        ></ModelGallery>
                      </v-col>
                      <v-col cols="12" class="pt-0">
                        <v-pagination
                          v-model="query_page_idx"
                          :length="query_page_len"
                          @input="fetchSamples(false)"
                        ></v-pagination>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-tab-item>
                <v-tab-item>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12">
                        <v-file-input
                          v-model="selected_file"
                          label="Upload a Visual Object"
                          outlined
                          clearable
                          hide-details
                          @change="onFileChange"
                        ></v-file-input>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-tab-item>
              </v-tabs>
            </v-col>
          </v-row>
          <v-row v-if="show_model" class="dense mt-0">
            <v-col cols="12" md="7" class="align-center justify-center">
              <v-card tile ref="meta_left">
                <v-responsive :aspect-ratio="10 / 7.5">
                  <model-viewer
                    loading="eager"
                    reveal="interaction"
                    camera-controls
                    auto-rotate
                    :src="query_model_src"
                    :poster="query_poster_src"
                    alt="failed to load model"
                    style="width: 100%; height: 100%"
                  ></model-viewer>
                </v-responsive>
              </v-card>
            </v-col>
            <v-col cols="12" md="5">
              <v-card :height="meta_height" class="overflow-y-auto" tile>
                <v-card-title class="text-h6 justify-center">
                  Meta
                </v-card-title>
                <div v-for="item in selected_sample['meta']" :key="item.idx">
                  <v-list-item two-line>
                    <v-list-item-content>
                      <v-list-item-title>{{ item.name }}</v-list-item-title>
                      <v-list-item-subtitle>{{
                        item.value
                      }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </div>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="d-flex justify-center">
              <v-btn
                v-if="show_model"
                color="primary"
                @click="retrieve_selected_sample"
                class="ma-2"
                large
              >
                <v-icon left>mdi-cloud-search-outline</v-icon>
                Retrieve the Object!
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
      <v-divider :vertical="this.$vuetify.breakpoint.mdAndUp" style="border-width: thin thin 0 0"></v-divider>
      <v-col cols="12" md="8">
        <v-container>
          <v-row dense>
            <v-col cols="12" md="2">
              <v-subheader class="text-subtitle-1 text-center">
                Target Dataset
              </v-subheader>
            </v-col>
            <v-col cols="12" md="10">
              <v-select
                v-model="target_datasets"
                :items="dataset_list"
                :menu-props="{ top: true, offsetY: true }"
                solo
                multiple
                chips
                hint="Select a target dataset"
                persistent-hint
              ></v-select>
            </v-col>
            <v-col cols="12" md="2" class="align-self-center">
              <v-subheader class="text-subtitle-1 text-center">
                Target Modality
              </v-subheader>
            </v-col>
            <v-col cols="12" md="10">
              <v-row>
                <v-col
                  v-for="modality in target_modality_checkbox"
                  :key="modality.idx"
                >
                  <v-checkbox
                    v-model="target_modalities[modality.code]"
                    :label="modality.name"
                    color="primary"
                    @change="retrieve_selected_sample(true)"
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row v-if="show_retrival_gallery">
            <v-col cols="12">
              <ModelGallery
                :addrPrefix="data_address"
                :modelList="retrieval_samples"
                :nRow="retrieval_n_row"
                :nCol="retrieval_n_col"
                @select-it="select_retrieved_sample(arguments)"
              ></ModelGallery>
            </v-col>
            <v-col cols="12" class="pt-0">
              <v-pagination
                :total-visible="8"
                v-model="retrieval_page_id"
                :length="retrieval_page_len"
                @input="retrieve_selected_sample(false)"
              ></v-pagination>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
    <v-dialog v-model="show_dialog" ref="dialog" :width="dialog_width">
      <ModelDetail
        :addrPrefix="data_address"
        :detail_items="dialog_details"
        :model_items="dialog_models"
        :init_tab="dialog_tab"
        @close-dialog="show_dialog = false"
        @second-retrieve="second_retrieve(arguments)"
      >
      </ModelDetail>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from "axios";
import ModelGallery from "./ModelGallery.vue";
import ModelDetail from "./ModelDetail.vue";

let base_url = "https://vors.moon-lab.tech:20080";
// let base_url = "http://166.111.82.233:3113";
let data_address = base_url + "/resource";
let info_address = base_url + "/info";
let retrieve_address = base_url + "/retrieve";
// config
let query_n_sample = 100;
let modality_map = {
  raw: "View",
  vox_32: "Voxel",
  pt_1024: "PointCloud",
};
let modality_list = [
  { code: "raw", idx: 0 },
  { code: "vox_32", idx: 1 },
  { code: "pt_1024", idx: 2 },
];

export default {
  name: "VORS",

  components: {
    ModelGallery,
    ModelDetail,
  },

  data: () => ({
    dataset_list: [],
    selected_file: null,
    selected_sample: null,
    show_model: false,
    show_query_gallery: false,
    show_retrival_gallery: false,
    show_dialog: false,
    query_datasets: [],
    query_samples: [],
    query_n_row: 3,
    query_n_col: 4,
    query_page_idx: 1,
    query_page_len: 1,
    data_address: data_address,
    meta_height: 0,
    target_datasets: [],
    target_modalities: {},
    retrieval_samples: [],
    retrieval_n_sample: 1000,
    retrieval_n_row: 4,
    retrieval_n_col: 6,
    retrieval_page_id: 1,
    second_retrieve_uuid: null,
    dialog_width: 0,
    dialog_details: [],
    dialog_models: [],
    dialog_tab: 0,
    dialog_modality: "raw",
  }),

  mounted() {
    window.onresize = () => {
      this.autoResize();
      this.autoUpdate();
    };
  },

  created() {
    // init target modality checkboxes
    for (let modality of modality_list) {
      this.target_modalities[modality.code] = true;
    }
    // init dataset list
    axios
      .get(info_address + "/dataset_list")
      .then((response) => {
        this.dataset_list = response.data;
        this.query_datasets.push(this.dataset_list[0]);
        this.target_datasets.push(this.dataset_list[0]);
        // init query samples
        this.autoResize();
        this.fetchSamples();
      })
      .catch((error) => {
        console.log(error);
      });
  },

  computed: {
    query_model_src: function () {
      return (
        data_address +
        "/" +
        this.selected_sample["uuid"] +
        "/" +
        this.selected_sample["modality"] +
        "/obj"
      );
    },
    query_poster_src: function () {
      return (
        data_address +
        "/" +
        this.selected_sample["uuid"] +
        "/" +
        this.selected_sample["modality"] +
        "/img"
      );
    },
    target_modality_checkbox: function () {
      let checkbox_list = [];
      for (let modality of modality_list) {
        checkbox_list.push({
          idx: modality.idx,
          code: modality.code,
          name: modality_map[modality.code],
        });
      }
      return checkbox_list;
    },
  },

  methods: {
    autoResize() {
      if (this.show_model) {
        this.meta_height = this.$refs.meta_left.$el.clientHeight;
      }
      if (this.$vuetify.breakpoint.mdAndUp) {
        this.query_n_row = 3;
        this.query_n_col = 4;
        this.retrieval_n_row = 4;
        this.retrieval_n_col = 6;
        this.dialog_width = window.innerWidth * 0.6;
      } else {
        this.query_n_row = 3;
        this.query_n_col = 3;
        this.retrieval_n_row = 3;
        this.retrieval_n_col = 3;
        this.dialog_width = window.innerWidth * 0.9;
      }
    },
    autoUpdate() {
      this.$nextTick(() => {
        this.fetchSamples(false);
        if (this.show_retrival_gallery) {
          this.retrieve_selected_sample(false);
        }
      });
    },
    onFileChange(e) {
      console.log(e.target.files[0]);
    },
    fetchSamples(refresh = false) {
      if (refresh) {
        this.query_page_idx = 1;
        this.show_model = false;
        this.show_retrival_gallery = false;
        this.selected_sample = null;
      }
      axios
        .post(info_address + "/samples", {
          dataset_list: this.query_datasets,
          n_sample: query_n_sample,
          n_each_page: this.query_n_row * this.query_n_col,
          page_id: this.query_page_idx,
          refresh: refresh,
        })
        .then((response) => {
          this.query_page_len = response.data.page_len;
          let query_raw_samples = response.data.sample;
          this.query_samples = this.formatGalleryModels(
            query_raw_samples,
            this.query_n_row,
            this.query_n_col
          );
          this.show_query_gallery = true;
          // default select first sample
          this.select_query_sample([
            this.query_samples[0].uuid,
            this.query_samples[0].modality,
          ]);
        });
    },
    formatGalleryModels(model_list, n_row, n_col) {
      let gallery_models = [];
      for (let i = 0; i < n_row * n_col; i++) {
        if (i < model_list.length) {
          gallery_models.push(model_list[i]);
          gallery_models[i].key = i;
        } else {
          gallery_models.push({
            uuid: null,
            key: i,
          });
        }
      }
      return gallery_models;
    },
    select_query_sample(e) {
      axios
        .get(info_address + "/meta", {
          params: {
            uuid: e[0],
            modality: e[1],
          },
        })
        .then((response) => {
          this.selected_sample = {
            uuid: e[0],
            modality: e[1],
            meta: response.data,
          };
          this.show_model = true;
          this.$nextTick(() => {
            this.meta_height = this.$refs.meta_left.$el.clientHeight;
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    retrieve_sample(uuid, modality) {
      let target_modality_list = [];
      for (let modality in this.target_modalities) {
        if (this.target_modalities[modality]) {
          target_modality_list.push(modality);
        }
      }
      axios
        .post(retrieve_address + "/v0", {
          uuid: uuid,
          modality: modality,
          target_datasets: this.target_datasets,
          target_modalities: target_modality_list,
          retrieval_n_sample: this.retrieval_n_sample,
          retrieval_n_each_page: this.retrieval_n_row * this.retrieval_n_col,
          retrieval_page_id: this.retrieval_page_id,
        })
        .then((response) => {
          // console.log(response.data);
          this.retrieval_page_len = response.data.page_len;
          let retrieval_raw_samples = response.data.sample;
          this.retrieval_samples = this.formatGalleryModels(
            retrieval_raw_samples,
            this.retrieval_n_row,
            this.retrieval_n_col
          );
          this.autoResize();
          this.show_retrival_gallery = true;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    retrieve_selected_sample(new_sample = true) {
      if (this.selected_sample == null) {
        return;
      }
      if (new_sample) {
        this.retrieval_page_id = 1;
      }
      this.retrieve_sample(
        this.selected_sample["uuid"],
        this.selected_sample["modality"]
      );
    },
    second_retrieve(e) {
      this.retrieval_page_id = 1;
      let modality = e[0];
      for (let m of modality_list) {
        if (m.idx == modality) {
          modality = m.code;
        }
      }
      // show it in 3D
      this.select_query_sample([this.second_retrieve_uuid, modality])
      // retrieve it 
      this.retrieve_sample(this.second_retrieve_uuid, modality);
      // close dialog
      this.show_dialog = false;
    },
    select_retrieved_sample(e) {
      this.second_retrieve_uuid = e[0];
      axios
        .get(info_address + "/detail_model", {
          params: {
            uuid: this.second_retrieve_uuid,
          },
        })
        .then((response) => {
          this.dialog_details = response.data.details;
          this.dialog_models = response.data.models;
          for (let m of modality_list) {
            if (m.code == e[1]) {
              this.dialog_tab = m.idx;
              break;
            }
          }
          this.autoResize();
          this.show_dialog = true;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>
